// extracted by mini-css-extract-plugin
export default {"tabContainer":"StudentRoutineDetails__tabContainer___Ttbjr","tabLabel":"StudentRoutineDetails__tabLabel___j8sIr","skeleton-loading":"StudentRoutineDetails__skeleton-loading___evE3F"};